import { render, staticRenderFns } from "./GenericTrash.vue?vue&type=template&id=968ae3b6"
import script from "./GenericTrash.vue?vue&type=script&lang=js"
export * from "./GenericTrash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports